import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex h-screen overflow-hidden" }
const _hoisted_2 = { class: "relative flex flex-col flex-1 overflow-x-hidden overflow-y-auto" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_RouterView = _resolveComponent("RouterView")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createCommentVNode(" <Header></Header> "),
      _createElementVNode("main", null, [
        _withDirectives(_createElementVNode("div", null, _cache[0] || (_cache[0] = [
          _createTextVNode(" Loading application state... "),
          _createElementVNode("br", null, null, -1 /* CACHED */),
          _createElementVNode("i", { class: "fa-solid fa-spinner fa-animate-spin" }, null, -1 /* CACHED */)
        ]), 512 /* NEED_PATCH */), [
          [_vShow, $setup.loading]
        ]),
        _withDirectives(_createVNode(_component_RouterView, null, null, 512 /* NEED_PATCH */), [
          [_vShow, !$setup.loading]
        ]),
        _createCommentVNode(" <Home></Home> ")
      ])
    ])
  ]))
}